import React, { useState, useEffect } from "react";
import axiosAPI from "../api/axiosApi";
import * as RB from "react-bootstrap";
import * as RC from "react-chartjs-2";
import { authFetch } from "../api/authenticationApi2";
import { STATS_URL } from "./params";
import "bootstrap/dist/css/bootstrap.css";
import "./InvestigationPage.css";

const row_count_set = {
    labels: [],
    datasets: [
        {
            label: "Число записей",
            fill: true,
            data: [],
            backgroundColor: "rgba(75,192,192,0.2)",
            borderColor: "rgba(75,192,192,1)",
        },
    ],
};

const pc_count_set = {
    labels: [],
    datasets: [
        {
            label: "Компьютеры",
            fill: true,
            data: [],
            backgroundColor: "#99ddff",
            borderColor: "rgba(75,192,192,1)",
        },
    ],
};

const mark_count_set = {
    labels: [],
    datasets: [
        {
            label: "Метки",
            fill: true,
            data: [],
            backgroundColor: "rgba(75,192,192,0.2)",
            borderColor: "rgba(75,192,192,1)",
        },
    ],
};

const department_count_set = {
    labels: [],
    datasets: [
        {
            label: "Департаменты",
            fill: true,
            data: [],
            backgroundColor: "rgba(75,192,192,0.2)",
            borderColor: "rgba(75,192,192,1)",
        },
    ],
};

const data = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
        {
            label: "First dataset",
            data: [33, 53, 85, 41, 44, 65],
            fill: true,
            backgroundColor: "rgba(75,192,192,0.2)",
            borderColor: "rgba(75,192,192,1)",
        },
        {
            label: "Second dataset",
            data: [33, 25, 35, 51, 54, 76],
            fill: false,
            borderColor: "#742774",
        },
    ],
};

import Header from "../common/Header";

export const DashboardPage = () => {
    const [sd_row_count_set, setRowCount] = useState(row_count_set);
    const [sd_pc_count_set, setPCCount] = useState(pc_count_set);
    const [sd_mark_count_set, setMarkerCount] = useState(mark_count_set);
    const [sd_department_count_set, setDepartmentCount] =
        useState(department_count_set);

    const getStatsData = async (itype) => {
        const response = await authFetch(STATS_URL, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();

        var row_count_set_ = JSON.parse(JSON.stringify(row_count_set));
        var mark_count_set_ = JSON.parse(JSON.stringify(mark_count_set));
        var pc_count_set_ = JSON.parse(JSON.stringify(pc_count_set));
        var department_count_set_ = JSON.parse(
            JSON.stringify(department_count_set)
        );
        for (var row in data) {
            var r_ = data[row];
            var dt_ = r_.dt;
            row_count_set_.labels.push(dt_);
            mark_count_set_.labels.push(dt_);
            pc_count_set_.labels.push(dt_);
            department_count_set_.labels.push(dt_);

            row_count_set_.datasets[0].data.push(r_.row_count);
            mark_count_set_.datasets[0].data.push(r_.mark_count);
            pc_count_set_.datasets[0].data.push(r_.pc_count);
            department_count_set_.datasets[0].data.push(r_.department_count);
        }

        setRowCount(row_count_set_);
        setPCCount(pc_count_set_);
        setMarkerCount(mark_count_set_);
        setDepartmentCount(department_count_set_);
    };

    useEffect(() => {
        getStatsData();
    }, []);

    return (
        <>
            <Header />
            <RB.Container fluid>
                <RB.Row className="align-items-center justify-content-center">
                    <RB.Col sm={5}>
                        <RB.Jumbotron style={{ margin: "1rem 0rem" }}>
                            <RC.Bar data={sd_row_count_set} />
                        </RB.Jumbotron>
                    </RB.Col>
                    <RB.Col sm={5}>
                        <RB.Jumbotron style={{ margin: "1rem 0rem" }}>
                            <RC.Bar data={sd_department_count_set} />
                        </RB.Jumbotron>
                    </RB.Col>
                </RB.Row>
                <RB.Row className="align-items-center justify-content-center">
                    <RB.Col sm={5}>
                        <RB.Jumbotron style={{ margin: "1rem 0rem" }}>
                            <RC.Bar data={sd_pc_count_set} />
                        </RB.Jumbotron>
                    </RB.Col>
                    <RB.Col sm={5}>
                        <RB.Jumbotron style={{ margin: "1rem 0rem" }}>
                            <RC.Bar data={sd_mark_count_set} />
                        </RB.Jumbotron>
                    </RB.Col>
                </RB.Row>
            </RB.Container>
        </>
    );
};
